export default {
  typography: {
    color: 'rgba(0, 0, 0, 0.6)',
    '&.MuiTypography-subtitle2': {
      padding: '24px',
      letterSpacing: '1.25px',
    },
  },
};
